import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_CIRCLE_CHECK_BIG: GlameraIconDefinition = {
  name: 'circle-check-big',
  viewBox: '0 0 24 24',
  svg: `
    <g class="glm-circle-check-big">
      <path class="glm-circle-check-ring" pathLength="1" d="M21.801 10A10 10 0 1 1 17 3.335"></path>
      <path class="glm-circle-check-tick" pathLength="1" d="m9 11 3 3L22 4"></path>
    </g>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-circle-check-big-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './circle-check-big.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class CircleCheckBigIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_CIRCLE_CHECK_BIG;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
